export const GET_REPORT_FOR_DUTY_LOG_REQUEST = "GET_REPORT_FOR_DUTY_LOG_REQUEST";
export const GET_REPORT_FOR_DUTY_LOG_SUCCESS = "GET_REPORT_FOR_DUTY_LOG_SUCCESS";
export const GET_REPORT_FOR_DUTY_LOG_FAILURE = "GET_REPORT_FOR_DUTY_LOG_FAILURE";
